import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getGamesList, useGetGamesDataQuery } from '../../redux/api/games';
import { useSelector } from 'react-redux';
import { useImagePreload } from '../../utils/hooks/useImagePreload';
import { useTranslation } from 'react-i18next';
import GameCard from '../gameCard';
import GameCardSkeleton from '../gameCard/skeleton';
import CarouselCards from '../../uiKit/carousel';
import Paragraph from '../../uiKit/typography/paragraph';
import { NavLink } from 'react-router-dom';


export default React.memo(function GamesSlider({
                                                 children, slideWidth = 260, speed = 10,
                                                 className = '', containerClassName = '',
                                                 direction = 'left'
                                               }) {
  const { t } = useTranslation('common');
  const { isFetching } = useGetGamesDataQuery();
  const gamesList = useSelector(getGamesList);
  const loaded = useImagePreload(gamesList.reduce((res, game) => {
    res.push(game.iconPreview, game.iconSquare);
    return res;
  }, []));

  const [current, setCurrent] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(1);
  const [openCardId, setOpenCardId] = useState(null);
  const [hasSlider, setHasSlider] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setSlideInfo();
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [gamesList]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev < slidesPerView.length - 1 ? prev + 1 : 0));
    }, 3000); // автопрокрутка кожні 3 секунди

    return () => clearInterval(interval);
  }, []);

  const onCardClick = useCallback((id) => {
    setOpenCardId(id);
  }, []);

  const setSlideInfo = useCallback(() => {
    const slidesAmount = Math.floor(window.innerWidth / (slideWidth + 16));
    setSlidesPerView(slidesAmount);
    setHasSlider(slidesAmount < gamesList.length)
  }, [slideWidth, gamesList]);

  return (!isFetching && !!gamesList.length && <>
      <Paragraph className={'text-center text-black text-3xl mb-8 mt-20'}>
        {t('titles.our_top_games')}
      </Paragraph>
      {hasSlider ? <CarouselCards slidesPerView={slidesPerView} loop={1000} //partialShow={true} partGutter={partGutter}
        // partImageOffset = {partGutter}
                                  className={`${slidesPerView === 1 ? '' : 'w-full'} ${containerClassName}`} // rounded-3xl

                                  itemClassName={'px-1 shrink-0 w-[260px] h-[260px]'}>

        {gamesList.map((game, index) => game && loaded.includes(game.iconSquare) && loaded.includes(game.iconPreview) ?
          <GameCard key={game.gameBundle} game={game} callback={onCardClick}
                    isOpen={game.id === openCardId} /> :
          <GameCardSkeleton key={index} />
        )}
      </CarouselCards> : <div className={`flex items-center justify-center h-[260px] ${containerClassName}`}>
        {gamesList.map((game, index) => game && loaded.includes(game.iconSquare) && loaded.includes(game.iconPreview) ?
          <GameCard key={game.gameBundle} game={game} callback={onCardClick}
                    isOpen={game.id === openCardId} className={'w-[260px] h-[260px]'} /> :
          <GameCardSkeleton key={index} className={'w-[260px] h-[260px] mx-1'} />
        )}
      </div>}
      <NavLink to={'/games'}
               className={({ isActive }) => `flex justify-center p-6 ${isActive ? '[&>span]:after:opacity-100' : '[&>span]:after:opacity-0'}`}>
            <span
              className={'flex justify-center w-full py-[5px] px-[15px] font-medium text-[15px] leading-[2.07] rounded-lg bg-brandedColor text-white overflow-hidden '}>
              <span className={'relative z-[1]'}>
                {t('buttons.our_games')}
              </span>
            </span>
      </NavLink>
    </>

  )
})
